export const CONNECTION_ERROR_DATA = {
    state: {
        title: 'login.error.internalServerError.title',
        body: 'login.error.internalServerError.body',
        img: 'conection_error',
    },
};
export const GENERIC_ERROR_DATA = {
    title: 'login.error.genericError.title',
    body: 'login.error.genericError.body',
    img: 'error_user',
};
